import { render, staticRenderFns } from "./store-products.vue?vue&type=template&id=be4041d2&scoped=true&"
import script from "./store-products.vue?vue&type=script&lang=js&"
export * from "./store-products.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4041d2",
  null
  
)

export default component.exports